export const reason_list = [
  "Others",
  "Address Line Different",
  "City Different",
  "CPIN Different",
  "DOB Different",
  "Email Different",
  "Family lists Different",
  "FN Different",
  "FN Initial Different",
  "Gender Different",
  "HICN Different",
  "Household Different",
  "HSID Different",
  "LN Different",
  "MBI Different",
  "Middle Initial Different",
  "Middle Name Different",
  "MRN Different",
  "Phone Different",
  "Postal Code Different",
  "SSN Different",
  "State Different",
  "UID Different"
];

export const overmergeCases = [
  "Not Related/Different Individuals",
  "Parent/Child being compared",
  "Siblings being compared",
  "Spouses being compared",
  "Twins case",
  "Other"
];

export const notOvermergeReasons = [
  "All data seems to match",
  "Address Line Same",
  "Address Typo",
  "Alternate ID Same",
  "Baby or Newborn name",
  "City Same",
  "CPIN Same",
  "DOB Same",
  "DOB Typo",
  "Email Same",
  "Email Typo",
  "FN Incomplete",
  "FN Initial Same",
  "FN Same",
  "FN Typo",
  "FN LN Inverted/Transpose",
  "FN Spacing/Concatenated",
  "Gender Same",
  "HICN Same",
  "HICN Typo",
  "Household Same",
  "HSID Same",
  "LN Incomplete",
  "LN Same",
  "LN Typo",
  "LN Change",
  "LN Spacing/Concatenated",
  "MBI Same",
  "MBI Typo",
  "MI spacing/concatenated",
  "Middle Initial Same",
  "Middle Initial Typo",
  "Middle initial used as a FN",
  "Middle Name Same",
  "Middle Name used as FN",
  "MRN Same",
  "Nickname used as FN",
  "Nickname used as LN",
  "Phone Same",
  "Phone Typo",
  "Postal Code Same",
  "SSN Same",
  "SSN Typo",
  "State Same",
  "Subscriber ID appearing in the SSN field",
  "UID Same",
  "Others"
];
